import { default as axios } from './axiosConfig'
import { commandResponse } from '@dataTypes/index'
import { getEnv } from '@utils/env'
import { logger } from '@utils/safeLogger'
import { toApiError } from './errors/api-error'

const DENTALASSISTANT_API_URL = getEnv('REACT_APP_DENTALASSISTANT_API_URL')

export const sendAudioCommand = async (
  body: FormData,
): Promise<commandResponse> => {
  try {
    const { data } = await axios.post<commandResponse>(
      'https://test-lzgwtcxtja-uc.a.run.app/sendcommand',
      body,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    return data
  } catch (e: unknown) {
    throw toApiError(e, 'Failed to send audio command')
  }
}

export const sendAudioCommandm = async (
  body: FormData,
  id: string,
  type: React.MutableRefObject<string>,
): Promise<commandResponse> => {
  /*
  Send audio stream data to voice assistant api 
  Args:
    body:                       FormData: send Audio data as blob with filename, first stream status
    id:                           string: Session Id as a unique identifier per user per id.
    type: React.MutableRefObject<string>: String to indicate if it's free or keyword
  Returns: 
    object: Object returned by the api
  */
  try {
    const { data } = await axios.post<commandResponse>(
      `${DENTALASSISTANT_API_URL}/sendcommandm/${id}/${type.current}`,
      body,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    return data
  } catch (e: unknown) {
    throw toApiError(e, 'Failed to send audio command')
  }
}

export const sendConnectCommand = async (
  body: FormData,
  id: string,
  type: React.MutableRefObject<string>,
): Promise<commandResponse> => {
  /*
  Initialize audio connection to voice assistant server 
  Args:
    body:                       FormData: send empty Audio data as blob with filename, first stream status
    id:                           string: Session Id as a unique identifier per user per id.
    type: React.MutableRefObject<string>: String to indicate if it's free or keyword
  Returns: 
    object: Object returned by the api to indicate connection status
  */
  try {
    const { data } = await axios.post<commandResponse>(
      `${DENTALASSISTANT_API_URL}/sendcommandm/${id}/${type.current}`,
      body,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    return data
  } catch (e: unknown) {
    logger.error('Error in sendAudioCommandm', e)
    throw toApiError(e, 'Failed to connect audio command')
  }
}

export const sendPing = async (): Promise<commandResponse> => {
  try {
    const { data } = await axios.get<commandResponse>(
      `${DENTALASSISTANT_API_URL}/ping`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    return data
  } catch (e: unknown) {
    throw toApiError(e, 'Failed to ping audio service')
  }
}
